import { createFileRoute } from '@tanstack/react-router';

import { preloadProgressData } from 'hooks/useQuery/useQueryProgressData';
import { preloadSourceApps } from 'hooks/useQuery/useQuerySourceApps';

import { MicroLearningsView } from 'views/MicroLearningsView';

export const Route = createFileRoute('/_auth/_layout/micro-learnings/')({
  component: MicroLearningsView,
  loader: async ({ context: { queryClient } }) => {
    await Promise.all([preloadSourceApps(queryClient), preloadProgressData(queryClient)]);
  },
});
